import { ListSubheader as NovaListSubHeader } from '@fme-nova/components'
import { default as MuiListSubHeader, ListSubheaderProps } from '@mui/material/ListSubheader'

import { createComponentWrapperWithRef } from '../../theme'

export const ListSubHeader = createComponentWrapperWithRef<ListSubheaderProps>(
  {
    mui: MuiListSubHeader,
    nova: NovaListSubHeader,
  },
  'ListSubHeader',
)
